export default {
    // === VAT INVOICE ND70 - 97 FIELDS ===
    formatXML_GTGT_ND70: [
        // === GENERAL INFORMATION - TTChung (17 fields) ===
        {
            TargetName: 'Tag HDon\\DLHDon\\TTChung',
            IsTitle: true
        },
        {
            TargetName: 'Message version',
            TagName: 'PBan',
            TagNameCheck: 'PBan',
            MaxLength: 6,
            DataType: 'String',
            Constraint: 'Mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\TTChung'
        },
        {
            TargetName: 'Invoice name',
            TagName: 'THDon',
            TagNameCheck: 'THDon',
            MaxLength: 100,
            DataType: 'String',
            Constraint: 'Mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\TTChung'
        },
        {
            TargetName: 'Invoice template symbol',
            TagName: 'KHMSHDon',
            TagNameCheck: 'KHMSHDon',
            MaxLength: 1,
            DataType: 'String (Details in Appendix II attached to Decision No. 1306/QD-CT)',
            Constraint: 'Mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\TTChung'
        },
        {
            TargetName: 'Invoice symbol',
            TagName: 'KHHDon',
            TagNameCheck: 'KHHDon',
            MaxLength: 6,
            DataType: 'String',
            Constraint: 'Mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\TTChung'
        },
        {
            TargetName: 'Invoice number',
            TagName: 'SHDon',
            TagNameCheck: 'SHDon',
            MaxLength: 8,
            DataType: 'Number',
            Constraint: 'Mandatory (if available)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\TTChung'
        },
        {
            TargetName: 'Profile code',
            TagName: 'MHSo',
            TagNameCheck: 'MHSo',
            MaxLength: 20,
            DataType: 'String',
            Constraint: 'Mandatory (for invoices requesting tax authority code on each occurrence)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\TTChung'
        },
        {
            TargetName: 'Date of issuance',
            TagName: 'NLap',
            TagNameCheck: 'NLap',
            DataType: 'Date',
            Constraint: 'Mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\TTChung'
        },
        {
            TargetName: 'Statement number (Number of statement of goods and services sold with invoice or commercial discount invoice)',
            TagName: 'SBKe',
            TagNameCheck: 'SBKe',
            MaxLength: 50,
            DataType: 'String',
            Constraint: 'Mandatory (if available)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\TTChung'
        },
        {
            TargetName: 'Statement date (Date of statement of goods and services sold with invoice or commercial discount invoice)',
            TagName: 'NBKe',
            TagNameCheck: 'NBKe',
            DataType: 'Date',
            Constraint: 'Mandatory (if available)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\TTChung'
        },
        {
            TargetName: 'Currency unit',
            TagName: 'DVTTe',
            TagNameCheck: 'DVTTe',
            MaxLength: 3,
            DataType: 'String (Details in Section 2, Item IV, Part I, Decision No. 1306/QD-CT)',
            Constraint: 'Mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\TTChung'
        },
        {
            TargetName: 'Exchange rate',
            TagName: 'TGia',
            TagNameCheck: 'TGia',
            MaxLength: '7,2',
            DataType: 'Number',
            Constraint: 'Mandatory (except when Currency unit is VND)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\TTChung'
        },
        {
            TargetName: 'Payment method',
            TagName: 'HTTToan',
            TagNameCheck: 'HTTToan',
            MaxLength: 50,
            DataType: 'String',
            Constraint: 'Mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\TTChung'
        },
        {
            TargetName: 'TIN of organization providing electronic invoice solutions',
            TagName: 'MSTTCGP',
            TagNameCheck: 'MSTTCGP',
            MaxLength: 14,
            DataType: 'String',
            Constraint: 'Mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\TTChung'
        },
        {
            TargetName: 'TIN of unit authorized to issue invoices',
            TagName: 'MSTDVNUNLHDon',
            TagNameCheck: 'MSTDVNUNLHDon',
            MaxLength: 14,
            DataType: 'String',
            Constraint: 'Mandatory (for invoice authorization cases)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\TTChung'
        },
        {
            TargetName: 'Name of unit authorized to issue invoices',
            TagName: 'TDVNUNLHDon',
            TagNameCheck: 'TDVNUNLHDon',
            MaxLength: 400,
            DataType: 'String',
            Constraint: 'Mandatory (for invoice authorization cases)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\TTChung'
        },
        {
            TargetName: 'Address of unit authorized to issue invoices',
            TagName: 'DCDVNUNLHDon',
            TagNameCheck: 'DCDVNUNLHDon',
            MaxLength: 400,
            DataType: 'String',
            Constraint: 'Mandatory (for invoice authorization cases)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\TTChung'
        },

        // === RELATED INVOICE INFORMATION - TTHDLQuan (10 fields) ===
        {
            TargetName: 'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan contains related invoice information for adjustment or replacement invoices',
            IsTitle: true
        },
        {
            TargetName: 'Invoice nature',
            TagName: 'TCHDon',
            TagNameCheck: 'TCHDon',
            MaxLength: 1,
            DataType: 'Number',
            Constraint: 'Mandatory (1: Replacement, 2: Adjustment, 3: Multiple invoice replacement, 4: Multiple invoice adjustment, 5: Commercial discount)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\TTChung\\TTHDLQuan'
        },
        {
            TargetName: 'Type of related invoice (Type of invoice being replaced/adjusted)',
            TagName: 'LHDCLQuan',
            TagNameCheck: 'LHDCLQuan',
            MaxLength: 1,
            DataType: 'Number (Details in Appendix VI attached to Decision No. 1306/QD-CT)',
            Constraint: 'Mandatory (for adjustment or replacement of 1 invoice)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\TTChung\\TTHDLQuan'
        },
        {
            TargetName: 'Template symbol of related invoice (Template symbol of invoice being replaced/adjusted)',
            TagName: 'KHMSHDCLQuan',
            TagNameCheck: 'KHMSHDCLQuan',
            MaxLength: 11,
            DataType: 'String (Details in Appendix II attached to Decision No. 1306/QD-CT)',
            Constraint: 'Mandatory (for adjustment or replacement of 1 invoice with Template symbol, Invoice symbol, Invoice number)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\TTChung\\TTHDLQuan'
        },
        {
            TargetName: 'Invoice symbol of related invoice (Invoice symbol of invoice being replaced/adjusted)',
            TagName: 'KHHDCLQuan',
            TagNameCheck: 'KHHDCLQuan',
            MaxLength: 8,
            DataType: 'String',
            Constraint: 'Mandatory (for adjustment or replacement of 1 invoice with Template symbol, Invoice symbol, Invoice number)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\TTChung\\TTHDLQuan'
        },
        {
            TargetName: 'Invoice number of related invoice (Invoice number of invoice being replaced/adjusted)',
            TagName: 'SHDCLQuan',
            TagNameCheck: 'SHDCLQuan',
            MaxLength: 8,
            DataType: 'String',
            Constraint: 'Mandatory (for adjustment or replacement of 1 invoice with Template symbol, Invoice symbol, Invoice number)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\TTChung\\TTHDLQuan'
        },
        {
            TargetName: 'Date of related invoice (Date of invoice being replaced/adjusted)',
            TagName: 'NLHDCLQuan',
            TagNameCheck: 'NLHDCLQuan',
            DataType: 'Date',
            Constraint: 'Mandatory (for adjustment or replacement of 1 invoice)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\TTChung\\TTHDLQuan'
        },
        {
            TargetName: 'Note',
            TagName: 'GChu',
            TagNameCheck: 'GChu',
            MaxLength: 255,
            DataType: 'String',
            Constraint: 'Not mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\TTChung\\TTHDLQuan'
        },
        {
            TargetName: 'Related statement number (Replacement/adjustment statement number)',
            TagName: 'SBKCLQuan',
            TagNameCheck: 'SBKCLQuan',
            MaxLength: 50,
            DataType: 'String',
            Constraint: 'Mandatory (for adjustment or replacement of multiple invoices)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\TTChung\\TTHDLQuan'
        },
        {
            TargetName: 'Related statement date (Date of replacement/adjustment statement)',
            TagName: 'NBKCLQuan',
            TagNameCheck: 'NBKCLQuan',
            DataType: 'Date',
            Constraint: 'Mandatory (for adjustment or replacement of multiple invoices)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\TTChung\\TTHDLQuan'
        },

        // === SELLER INFORMATION - NBan (11 fields) ===
        {
            TargetName: 'Tag HDon\\DLHDon\\NDHDon\\NBan',
            IsTitle: true
        },
        {
            TargetName: 'Name',
            TagName: 'Ten',
            TagNameCheck: 'Ten',
            MaxLength: 400,
            DataType: 'String',
            Constraint: 'Mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\NBan'
        },
        {
            TargetName: 'Tax code',
            TagName: 'MST',
            TagNameCheck: 'MST',
            MaxLength: 14,
            DataType: 'String',
            Constraint: 'Mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\NBan'
        },
        {
            TargetName: 'Address',
            TagName: 'DChi',
            TagNameCheck: 'DChi',
            MaxLength: 400,
            DataType: 'String',
            Constraint: 'Mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\NBan'
        },
        {
            TargetName: 'Store code',
            TagName: 'MCHang',
            TagNameCheck: 'MCHang',
            MaxLength: 50,
            DataType: 'String',
            Constraint: 'Not mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\NBan'
        },
        {
            TargetName: 'Store name',
            TagName: 'TCHang',
            TagNameCheck: 'TCHang',
            MaxLength: 400,
            DataType: 'String',
            Constraint: 'Not mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\NBan'
        },
        {
            TargetName: 'Phone number',
            TagName: 'SDThoai',
            TagNameCheck: 'SDThoai',
            MaxLength: 20,
            DataType: 'String',
            Constraint: 'Not mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\NBan'
        },
        {
            TargetName: 'Email address',
            TagName: 'DCTDTu',
            TagNameCheck: 'DCTDTu',
            MaxLength: 50,
            DataType: 'String',
            Constraint: 'Not mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\NBan'
        },
        {
            TargetName: 'Bank account number',
            TagName: 'STKNHang',
            TagNameCheck: 'STKNHang',
            MaxLength: 30,
            DataType: 'String',
            Constraint: 'Not mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\NBan'
        },
        {
            TargetName: 'Bank name',
            TagName: 'TNHang',
            TagNameCheck: 'TNHang',
            MaxLength: 400,
            DataType: 'String',
            Constraint: 'Not mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\NBan'
        },
        {
            TargetName: 'Fax',
            TagName: 'Fax',
            TagNameCheck: 'Fax',
            MaxLength: 20,
            DataType: 'String',
            Constraint: 'Not mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\NBan'
        },
        {
            TargetName: 'Website',
            TagName: 'Website',
            TagNameCheck: 'Website',
            MaxLength: 100,
            DataType: 'String',
            Constraint: 'Not mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\NBan'
        },

        // === BUYER INFORMATION - NMua (12 fields) ===
        {
            TargetName: 'Tag HDon\\DLHDon\\NDHDon\\NMua',
            IsTitle: true
        },
        {
            TargetName: 'Name',
            TagName: 'Ten',
            TagNameCheck: 'Ten',
            MaxLength: 400,
            DataType: 'String',
            Constraint: 'Mandatory (if available)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\NMua'
        },
        {
            TargetName: 'Tax code',
            TagName: 'MST',
            TagNameCheck: 'MST',
            MaxLength: 14,
            DataType: 'String',
            Constraint: 'Mandatory (if available)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\NMua'
        },
        {
            TargetName: 'Budget relationship unit code',
            TagName: 'MDVQHNSach',
            TagNameCheck: 'MDVQHNSach',
            MaxLength: 7,
            DataType: 'String',
            Constraint: 'Mandatory (if available)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\NMua'
        },
        {
            TargetName: 'Address',
            TagName: 'DChi',
            TagNameCheck: 'DChi',
            MaxLength: 400,
            DataType: 'String',
            Constraint: 'Mandatory (if available)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\NMua'
        },
        {
            TargetName: 'Customer code',
            TagName: 'MKHang',
            TagNameCheck: 'MKHang',
            MaxLength: 50,
            DataType: 'String',
            Constraint: 'Not mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\NMua'
        },
        {
            TargetName: 'Phone number',
            TagName: 'SDThoai',
            TagNameCheck: 'SDThoai',
            MaxLength: 20,
            DataType: 'String',
            Constraint: 'Not mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\NMua'
        },
        {
            TargetName: 'Citizen identification card (ID number/Citizen ID/Identification number)',
            TagName: 'CCCDan',
            TagNameCheck: 'CCCDan',
            MaxLength: 12,
            DataType: 'String',
            Constraint: 'Mandatory (if available)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\NMua'
        },
        {
            TargetName: 'Passport number (Passport number/Immigration documents)',
            TagName: 'SHChieu',
            TagNameCheck: 'SHChieu',
            MaxLength: 20,
            DataType: 'String',
            Constraint: 'Mandatory (if available)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\NMua'
        },
        {
            TargetName: 'Email address',
            TagName: 'DCTDTu',
            TagNameCheck: 'DCTDTu',
            MaxLength: 50,
            DataType: 'String',
            Constraint: 'Not mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\NMua'
        },
        {
            TargetName: 'Full name of buyer',
            TagName: 'HVTNMHang',
            TagNameCheck: 'HVTNMHang',
            MaxLength: 100,
            DataType: 'String',
            Constraint: 'Not mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\NMua'
        },
        {
            TargetName: 'Bank account number',
            TagName: 'STKNHang',
            TagNameCheck: 'STKNHang',
            MaxLength: 30,
            DataType: 'String',
            Constraint: 'Not mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\NMua'
        },
        {
            TargetName: 'Bank name',
            TagName: 'TNHang',
            TagNameCheck: 'TNHang',
            MaxLength: 400,
            DataType: 'String',
            Constraint: 'Not mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\NMua'
        },

        // === GOODS/SERVICES DETAILS - HHDVu (15 fields) ===
        {
            TargetName: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu',
            IsTitle: true
        },
        {
            TargetName: 'Nature',
            TagName: 'TChat',
            TagNameCheck: 'TChat',
            MaxLength: 1,
            DataType: 'Number (Details in Appendix IV Decision No. 1306/QD-CT)',
            Constraint: 'Mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
        },
        {
            TargetName: 'Serial number',
            TagName: 'STT',
            TagNameCheck: 'STT',
            MaxLength: 4,
            DataType: 'Number',
            Constraint: 'Not mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
        },
        {
            TargetName: 'Goods/services code',
            TagName: 'MHHDVu',
            TagNameCheck: 'MHHDVu',
            MaxLength: 50,
            DataType: 'String',
            Constraint: 'Mandatory (if available)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
        },
        {
            TargetName: 'Goods/services name',
            TagName: 'THHDVu',
            TagNameCheck: 'THHDVu',
            MaxLength: 500,
            DataType: 'String',
            Constraint: 'Mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
        },
        {
            TargetName: 'Unit of measurement',
            TagName: 'DVTinh',
            TagNameCheck: 'DVTinh',
            MaxLength: 50,
            DataType: 'String',
            Constraint: 'Mandatory (if available)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
        },
        {
            TargetName: 'Quantity',
            TagName: 'SLuong',
            TagNameCheck: 'SLuong',
            MaxLength: '21,6',
            DataType: 'Number',
            Constraint: 'Mandatory (if available)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
        },
        {
            TargetName: 'Unit price',
            TagName: 'DGia',
            TagNameCheck: 'DGia',
            MaxLength: '21,6',
            DataType: 'Number',
            Constraint: 'Mandatory (if available)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
        },
        {
            TargetName: 'Discount rate (%) (for showing discount information for each goods/service)',
            TagName: 'TLCKhau',
            TagNameCheck: 'TLCKhau',
            MaxLength: '6,4',
            DataType: 'Number',
            Constraint: 'Not mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
        },
        {
            TargetName: 'Discount amount (for showing discount information for each goods/service)',
            TagName: 'STCKhau',
            TagNameCheck: 'STCKhau',
            MaxLength: '21,6',
            DataType: 'Number',
            Constraint: 'Not mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
        },
        {
            TargetName: 'Amount (Amount excluding VAT)',
            TagName: 'ThTien',
            TagNameCheck: 'ThTien',
            MaxLength: '21,6',
            DataType: 'Number',
            Constraint: 'Mandatory (except when TChat value is "4-Note/explanation")',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
        },
        {
            TargetName: 'Tax rate (VAT tax rate)',
            TagName: 'TSuat',
            TagNameCheck: 'TSuat',
            MaxLength: 11,
            DataType: 'String (Details in Appendix V Decision No. 1306/QD-CT)',
            Constraint: 'Mandatory (if available)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
        },

        // === SPECIAL GOODS INFORMATION - TTHHDTrung (3 new fields ND70) ===
        {
            TargetName: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu\\TTHHDTrung\\Ttin contains list of special goods information (mandatory if TChat tag value is "5")',
            IsTitle: true
        },
        {
            TargetName: 'Special goods type',
            TagName: 'LHHDTrung',
            TagNameCheck: 'LHHDTrung',
            MaxLength: 1,
            DataType: 'Number (Details in Appendix XV, Decision No. 1306/QD-CT)',
            Constraint: 'Mandatory (if available)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu\\TTHHDTrung\\Ttin'
        },
        {
            TargetName: 'Field name',
            TagName: 'TTruong',
            TagNameCheck: 'TTruong',
            MaxLength: 20,
            DataType: 'String (Details in "Mandatory value" column in Appendix XV Decision No. 1306/QD-CT)',
            Constraint: 'Mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu\\TTHHDTrung\\Ttin'
        },
        {
            TargetName: 'Data',
            TagName: 'DLieu',
            TagNameCheck: 'DLieu',
            MaxLength: 200,
            DataType: '',
            Constraint: 'Mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu\\TTHHDTrung\\Ttin'
        },

        // === TAX RATE INFORMATION - LTSuat (3 fields) ===
        {
            TargetName: 'Tag HDon\\DLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat',
            IsTitle: true
        },
        {
            TargetName: 'Tax rate (VAT tax rate)',
            TagName: 'TSuat',
            TagNameCheck: 'TSuat',
            MaxLength: 11,
            DataType: 'String (Details in Appendix V Decision No. 1306/QD-CT)',
            Constraint: 'Mandatory (if available)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat'
        },
        {
            TargetName: 'Amount (Amount excluding VAT)',
            TagName: 'ThTien',
            TagNameCheck: 'ThTien',
            MaxLength: '21,6',
            DataType: 'Number',
            Constraint: 'Mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat'
        },
        {
            TargetName: 'Tax amount (VAT tax amount)',
            TagName: 'TThue',
            TagNameCheck: 'TThue',
            MaxLength: '21,6',
            DataType: 'Number',
            Constraint: 'Mandatory (if available)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat'
        },

        // === PAYMENT INFORMATION - TToan (8 fields) ===
        {
            TargetName: 'Tag HDon\\DLHDon\\NDHDon\\TToan',
            IsTitle: true
        },
        {
            TargetName: 'Total amount excluding tax (Total amount excluding VAT)',
            TagName: 'TgTCThue',
            TagNameCheck: 'TgTCThue',
            MaxLength: '21,6',
            DataType: 'Number',
            Constraint: 'Mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan'
        },
        {
            TargetName: 'Total non-taxable deduction',
            TagName: 'TGTKCThue',
            TagNameCheck: 'TGTKCThue',
            MaxLength: '21,6',
            DataType: 'Number',
            Constraint: 'Not mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan'
        },
        {
            TargetName: 'Total tax amount (Total VAT amount)',
            TagName: 'TgTThue',
            TagNameCheck: 'TgTThue',
            MaxLength: '21,6',
            DataType: 'Number',
            Constraint: 'Mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan'
        },
        {
            TargetName: 'Tag HDon\\DLHDon\\NDHDon\\TToan\\DSLPhi\\LPhi',
            IsTitle: true,
        },
        {
            TargetName: 'Fee type name',
            TagName: 'TLPhi',
            TagNameCheck: 'TLPhi',
            MaxLength: 100,
            DataType: 'String',
            Constraint: 'Mandatory (if available)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan\\DSLPhi\\LPhi'
        },
        {
            TargetName: 'Fee amount',
            TagName: 'TPhi',
            TagNameCheck: 'TPhi',
            MaxLength: '21,6',
            DataType: 'Number',
            Constraint: 'Mandatory (if available)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan\\DSLPhi\\LPhi'
        },
        {
            TargetName: 'Following items are placed inside tag HDon\\DLHDon\\NDHDon\\TToan',
            IsTitle: true,
        },
        {
            TargetName: 'Total commercial discount amount',
            TagName: 'TTCKTMai',
            TagNameCheck: 'TTCKTMai',
            MaxLength: '21,6',
            DataType: 'Number',
            Constraint: 'Mandatory (if available)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan'
        },
        {
            TargetName: 'Total other deductions',
            TagName: 'TGTKhac',
            TagNameCheck: 'TGTKhac',
            MaxLength: '21,6',
            DataType: 'Number',
            Constraint: 'Not mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan'
        },
        {
            TargetName: 'Total payment amount in numbers',
            TagName: 'TgTTTBSo',
            TagNameCheck: 'TgTTTBSo',
            MaxLength: '21,6',
            DataType: 'Number',
            Constraint: 'Mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan'
        },
        {
            TargetName: 'Total payment amount in words',
            TagName: 'TgTTTBChu',
            TagNameCheck: 'TgTTTBChu',
            MaxLength: 255,
            DataType: 'String',
            Constraint: 'Mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan'
        },

        // === QR CODE AND DIGITAL SIGNATURE (4 fields) ===
        {
            TargetName: 'HDon\\DLQRCode contains QR Code data',
            IsTitle: true
        },
        {
            TargetName: 'QR Code data (Details in Section 7, Item IV, Part I, Decision No. 1306/QD-CT)',
            TagName: '',
            TagNameCheck: 'DLQRCode',
            MaxLength: 512,
            DataType: 'String',
            Constraint: '',
            IsTitle: false,
            PathRoot: 'HDon\\DLQRCode'
        },
        {
            TargetName: 'For coded electronic invoices, if conditions are met for code issuance, tax authority system returns Tax authority code item on electronic invoice (MCCQT tag, placed inside HDon tag)',
            IsTitle: true,
        },
        {
            TargetName: 'Tax authority code',
            TagName: 'MCCQT',
            TagNameCheck: 'MCCQT',
            MaxLength: 34,
            DataType: 'String',
            Constraint: '',
            IsTitle: false,
            PathRoot: 'HDon'
        },
        {
            TargetName: 'Tag HDon\\DSCKS\\NBan',
            IsTitle: true
        },
        {
            TargetName: 'Seller digital signature',
            TagName: 'Signature',
            TagNameCheck: 'Signature',
            DataType: '',
            Constraint: 'Mandatory (if available)',
            IsTitle: false,
            PathRoot: 'HDon\\DSCKS\\NBan'
        },
        {
            TargetName: 'Tag HDon\\DSCKS\\NMua',
            IsTitle: true
        },
        {
            TargetName: 'Buyer digital signature',
            TagName: 'Signature',
            TagNameCheck: 'Signature',
            DataType: '',
            Constraint: 'Not mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DSCKS\\NMua'
        },
        {
            TargetName: 'For electronic invoices eligible for code issuance, tax authority system returns electronic invoice and adds CQT tag (placed inside HDon\\DSCKS tag) containing tax authority digital signature information (signed on HDon\\DLHDon tag, HDon\\MCCQT tag and HDon\\DSCKS\\CQT\\Signature\\Object tag)',
            IsTitle: true,
        },
        {
            TargetName: 'Tax authority digital signature',
            TagName: 'Signature',
            TagNameCheck: 'Signature',
            DataType: '',
            Constraint: 'Mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DSCKS\\CQT'
        }
    ],

    // === VAT INVOICE FOR CASH REGISTER ND70 ===
    formatXML_GTGT_MTT_ND70: [
        // === GENERAL INFORMATION - TTChung (10 fields for cash register) ===
        {
            TargetName: 'Tag HDon\\DLHDon\\TTChung',
            IsTitle: true
        },
        {
            TargetName: 'Message version',
            TagName: 'PBan',
            TagNameCheck: 'PBan',
            MaxLength: 6,
            DataType: 'String',
            Constraint: 'Mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\TTChung'
        },
        {
            TargetName: 'Invoice name',
            TagName: 'THDon',
            TagNameCheck: 'THDon',
            MaxLength: 100,
            DataType: 'String',
            Constraint: 'Mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\TTChung'
        },
        {
            TargetName: 'Invoice template symbol',
            TagName: 'KHMSHDon',
            TagNameCheck: 'KHMSHDon',
            MaxLength: 1,
            DataType: 'String (Details in Appendix II attached to Decision No. 1306/QD-CT)',
            Constraint: 'Mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\TTChung'
        },
        {
            TargetName: 'Invoice symbol',
            TagName: 'KHHDon',
            TagNameCheck: 'KHHDon',
            MaxLength: 6,
            DataType: 'String',
            Constraint: 'Mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\TTChung'
        },
        {
            TargetName: 'Invoice number',
            TagName: 'SHDon',
            TagNameCheck: 'SHDon',
            MaxLength: 8,
            DataType: 'Number',
            Constraint: 'Mandatory (if available)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\TTChung'
        },
        {
            TargetName: 'Date of issuance',
            TagName: 'NLap',
            TagNameCheck: 'NLap',
            DataType: 'Date',
            Constraint: 'Mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\TTChung'
        },
        {
            TargetName: 'Statement number (Number of statement of goods and services sold with invoice or commercial discount invoice)',
            TagName: 'SBKe',
            TagNameCheck: 'SBKe',
            MaxLength: 50,
            DataType: 'String',
            Constraint: 'Mandatory (if available)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\TTChung'
        },
        {
            TargetName: 'Statement date (Date of statement of goods and services sold with invoice or commercial discount invoice)',
            TagName: 'NBKe',
            TagNameCheck: 'NBKe',
            DataType: 'Date',
            Constraint: 'Mandatory (if available)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\TTChung'
        },
        {
            TargetName: 'Payment method',
            TagName: 'HTTToan',
            TagNameCheck: 'HTTToan',
            MaxLength: 50,
            DataType: 'String',
            Constraint: 'Mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\TTChung'
        },
        // === RELATED INVOICE INFORMATION - TTHDLQuan (6 fields for cash register) ===
        {
            TargetName: 'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan contains related invoice information for adjustment or replacement invoices',
            IsTitle: true
        },
        {
            TargetName: 'Invoice nature',
            TagName: 'TCHDon',
            TagNameCheck: 'TCHDon',
            MaxLength: 1,
            DataType: 'Number (1: Replacement, 2: Adjustment, 5: Commercial discount)',
            Constraint: 'Mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\TTChung\\TTHDLQuan'
        },
        {
            TargetName: 'Type of related invoice (Type of invoice being replaced/adjusted)',
            TagName: 'LHDCLQuan',
            TagNameCheck: 'LHDCLQuan',
            MaxLength: 1,
            DataType: 'Number (Details in Appendix VI attached to Decision No. 1306/QD-CT)',
            Constraint: 'Mandatory (for adjustment or replacement of 1 invoice)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\TTChung\\TTHDLQuan'
        },
        {
            TargetName: 'Template symbol of related invoice (Template symbol of invoice being replaced/adjusted)',
            TagName: 'KHMSHDCLQuan',
            TagNameCheck: 'KHMSHDCLQuan',
            MaxLength: 11,
            DataType: 'String (Details in Appendix II attached to Decision No. 1306/QD-CT)',
            Constraint: 'Mandatory (for adjustment or replacement of 1 invoice)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\TTChung\\TTHDLQuan'
        },
        {
            TargetName: 'Invoice symbol of related invoice (Invoice symbol of invoice being replaced/adjusted)',
            TagName: 'KHHDCLQuan',
            TagNameCheck: 'KHHDCLQuan',
            MaxLength: 8,
            DataType: 'String',
            Constraint: 'Mandatory (for adjustment or replacement of 1 invoice)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\TTChung\\TTHDLQuan'
        },
        {
            TargetName: 'Invoice number of related invoice (Invoice number of invoice being replaced/adjusted)',
            TagName: 'SHDCLQuan',
            TagNameCheck: 'SHDCLQuan',
            MaxLength: 8,
            DataType: 'String',
            Constraint: 'Mandatory (for adjustment or replacement of 1 invoice)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\TTChung\\TTHDLQuan'
        },
        {
            TargetName: 'Date of related invoice (Date of invoice being replaced/adjusted)',
            TagName: 'NLHDCLQuan',
            TagNameCheck: 'NLHDCLQuan',
            DataType: 'Date',
            Constraint: 'Mandatory (for adjustment or replacement of 1 invoice)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\TTChung\\TTHDLQuan'
        },
        // === SELLER INFORMATION - NBan (8 fields for cash register) ===
        {
            TargetName: 'Tag HDon\\DLHDon\\NDHDon\\NBan',
            IsTitle: true
        },
        {
            TargetName: 'Seller unit name',
            TagName: 'Ten',
            TagNameCheck: 'Ten',
            MaxLength: 400,
            DataType: 'String',
            Constraint: 'Mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\NBan'
        },
        {
            TargetName: 'Tax identification number',
            TagName: 'MST',
            TagNameCheck: 'MST',
            MaxLength: 14,
            DataType: 'String',
            Constraint: 'Mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\NBan'
        },
        {
            TargetName: 'Address',
            TagName: 'DChi',
            TagNameCheck: 'DChi',
            MaxLength: 400,
            DataType: 'String',
            Constraint: 'Mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\NBan'
        },
        {
            TargetName: 'Store code',
            TagName: 'MCHang',
            TagNameCheck: 'MCHang',
            MaxLength: 50,
            DataType: 'String',
            Constraint: 'Mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\NBan'
        },
        {
            TargetName: 'Store name',
            TagName: 'TCHang',
            TagNameCheck: 'TCHang',
            MaxLength: 400,
            DataType: 'String',
            Constraint: 'Mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\NBan'
        },
        {
            TargetName: 'Phone number',
            TagName: 'SDThoai',
            TagNameCheck: 'SDThoai',
            MaxLength: 20,
            DataType: 'String',
            Constraint: 'Mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\NBan'
        },
        {
            TargetName: 'Bank account number',
            TagName: 'STKNHang',
            TagNameCheck: 'STKNHang',
            MaxLength: 30,
            DataType: 'String',
            Constraint: 'Mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\NBan'
        },
        {
            TargetName: 'Bank name',
            TagName: 'TNHang',
            TagNameCheck: 'TNHang',
            MaxLength: 400,
            DataType: 'String',
            Constraint: 'Mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\NBan'
        },
        // === BUYER INFORMATION - NMua (8 fields for cash register) ===
        {
            TargetName: 'Tag HDon\\DLHDon\\NDHDon\\NMua',
            IsTitle: true
        },
        {
            TargetName: 'Full name of buyer',
            TagName: 'HVTNMHang',
            TagNameCheck: 'HVTNMHang',
            MaxLength: 100,
            DataType: 'String',
            Constraint: 'Mandatory (if available)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\NMua'
        },
        {
            TargetName: 'Buyer unit name',
            TagName: 'Ten',
            TagNameCheck: 'Ten',
            MaxLength: 400,
            DataType: 'String',
            Constraint: 'Mandatory (if available)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\NMua'
        },
        {
            TargetName: 'Tax identification number',
            TagName: 'MST',
            TagNameCheck: 'MST',
            MaxLength: 14,
            DataType: 'String',
            Constraint: 'Mandatory (if available)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\NMua'
        },
        {
            TargetName: 'Budget relationship unit code',
            TagName: 'MDVQHNSach',
            TagNameCheck: 'MDVQHNSach',
            MaxLength: 7,
            DataType: 'String',
            Constraint: 'Mandatory (if available)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\NMua'
        },
        {
            TargetName: 'Address',
            TagName: 'DChi',
            TagNameCheck: 'DChi',
            MaxLength: 400,
            DataType: 'String',
            Constraint: 'Mandatory (if available)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\NMua'
        },
        {
            TargetName: 'Phone number',
            TagName: 'SDThoai',
            TagNameCheck: 'SDThoai',
            MaxLength: 20,
            DataType: 'String',
            Constraint: 'Mandatory (if available)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\NMua'
        },
        {
            TargetName: 'Citizen identification card (ID number/Citizen ID/Identification number)',
            TagName: 'CCCDan',
            TagNameCheck: 'CCCDan',
            MaxLength: 12,
            DataType: 'String',
            Constraint: 'Mandatory (if available)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\NMua'
        },
        {
            TargetName: 'Passport number (Passport number/Immigration documents)',
            TagName: 'SHChieu',
            TagNameCheck: 'SHChieu',
            MaxLength: 20,
            DataType: 'String',
            Constraint: 'Mandatory (if available)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\NMua'
        },
        // === GOODS/SERVICES DETAILS - HHDVu (11 fields for cash register) ===
        {
            TargetName: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu',
            IsTitle: true
        },
        {
            TargetName: 'Nature',
            TagName: 'TChat',
            TagNameCheck: 'TChat',
            MaxLength: 1,
            DataType: 'Number (Details in Appendix IV attached to Decision No. 1306/QD-CT)',
            Constraint: 'Mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
        },
        {
            TargetName: 'Serial number',
            TagName: 'STT',
            TagNameCheck: 'STT',
            MaxLength: 4,
            DataType: 'Number',
            Constraint: 'Mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
        },
        {
            TargetName: 'Goods/services code',
            TagName: 'MHHDVu',
            TagNameCheck: 'MHHDVu',
            MaxLength: 50,
            DataType: 'String',
            Constraint: 'Mandatory (if available)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
        },
        {
            TargetName: 'Goods/services name',
            TagName: 'THHDVu',
            TagNameCheck: 'THHDVu',
            MaxLength: 500,
            DataType: 'String',
            Constraint: 'Mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
        },
        {
            TargetName: 'Unit of measurement',
            TagName: 'DVTinh',
            TagNameCheck: 'DVTinh',
            MaxLength: 50,
            DataType: 'String',
            Constraint: 'Mandatory (if available)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
        },
        {
            TargetName: 'Quantity',
            TagName: 'SLuong',
            TagNameCheck: 'SLuong',
            MaxLength: '21,6',
            DataType: 'Number',
            Constraint: 'Mandatory (if available)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
        },
        {
            TargetName: 'Unit price',
            TagName: 'DGia',
            TagNameCheck: 'DGia',
            MaxLength: '21,6',
            DataType: 'Number',
            Constraint: 'Mandatory (if available)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
        },
        {
            TargetName: 'Discount rate percentage (for displaying discount information for each goods/service)',
            TagName: 'TLCKhau',
            TagNameCheck: 'TLCKhau',
            MaxLength: '6,4',
            DataType: 'Number',
            Constraint: 'Mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
        },
        {
            TargetName: 'Discount amount (for displaying discount information for each goods/service)',
            TagName: 'STCKhau',
            TagNameCheck: 'STCKhau',
            MaxLength: '21,6',
            DataType: 'Number',
            Constraint: 'Mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
        },
        {
            TargetName: 'Amount (Amount excluding VAT)',
            TagName: 'ThTien',
            TagNameCheck: 'ThTien',
            MaxLength: '21,6',
            DataType: 'Number',
            Constraint: 'Mandatory (except when TChat value is "4-Note/explanation")',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
        },
        {
            TargetName: 'Tax rate (VAT tax rate)',
            TagName: 'TSuat',
            TagNameCheck: 'TSuat',
            MaxLength: 11,
            DataType: 'String (Details in Appendix V attached to Decision No. 1306/QD-CT)',
            Constraint: 'Mandatory (if available)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
        },

        // === SPECIAL GOODS INFORMATION - TTHHDTrung (3 new fields ND70) ===
        {
            TargetName: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu\\TTHHDTrung\\Ttin contains list of special goods information (mandatory if TChat tag value is "5")',
            IsTitle: true
        },
        {
            TargetName: 'Special goods type',
            TagName: 'LHHDTrung',
            TagNameCheck: 'LHHDTrung',
            MaxLength: 1,
            DataType: 'Number (Details in Appendix XV, Decision No. 1306/QD-CT)',
            Constraint: 'Mandatory (if available)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu\\TTHHDTrung\\Ttin'
        },
        {
            TargetName: 'Field name',
            TagName: 'TTruong',
            TagNameCheck: 'TTruong',
            MaxLength: 20,
            DataType: 'String (Details in "Mandatory value" column in Appendix XV Decision No. 1306/QD-CT)',
            Constraint: 'Mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu\\TTHHDTrung\\Ttin'
        },
        {
            TargetName: 'Data',
            TagName: 'DLieu',
            TagNameCheck: 'DLieu',
            MaxLength: 200,
            DataType: '',
            Constraint: 'Mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu\\TTHHDTrung\\Ttin'
        },

        // === TAX RATE INFORMATION - LTSuat (3 fields) ===
        {
            TargetName: 'Tag HDon\\DLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat',
            IsTitle: true
        },
        {
            TargetName: 'Tax rate (VAT tax rate)',
            TagName: 'TSuat',
            TagNameCheck: 'TSuat',
            MaxLength: 11,
            DataType: 'String (Details in Appendix V attached to Decision No. 1306/QD-CT)',
            Constraint: 'Mandatory (if available)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat'
        },
        {
            TargetName: 'Amount (Total amount excluding VAT by each tax rate type)',
            TagName: 'ThTien',
            TagNameCheck: 'ThTien',
            MaxLength: '21,6',
            DataType: 'Number',
            Constraint: 'Mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat'
        },
        {
            TargetName: 'Tax amount (VAT tax amount)',
            TagName: 'TThue',
            TagNameCheck: 'TThue',
            MaxLength: '21,6',
            DataType: 'Number',
            Constraint: 'Mandatory (if available)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat'
        },

        // === PAYMENT INFORMATION - TToan (5 fields for cash register) ===
        {
            TargetName: 'Tag HDon\\DLHDon\\NDHDon\\TToan',
            IsTitle: true
        },
        {
            TargetName: 'Total amount excluding tax (Total amount excluding VAT)',
            TagName: 'TgTCThue',
            TagNameCheck: 'TgTCThue',
            MaxLength: '21,6',
            DataType: 'Number',
            Constraint: 'Mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan'
        },
        {
            TargetName: 'Total tax amount (Total VAT amount)',
            TagName: 'TgTThue',
            TagNameCheck: 'TgTThue',
            MaxLength: '21,6',
            DataType: 'Number',
            Constraint: 'Mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan'
        },
        {
            TargetName: 'Following items are placed inside tag HDon\\DLHDon\\NDHDon\\TToan',
            IsTitle: true,
        },
        {
            TargetName: 'Total commercial discount amount',
            TagName: 'TTCKTMai',
            TagNameCheck: 'TTCKTMai',
            MaxLength: '21,6',
            DataType: 'Number',
            Constraint: 'Mandatory (if available)',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan'
        },
        {
            TargetName: 'Total payment amount in numbers',
            TagName: 'TgTTTBSo',
            TagNameCheck: 'TgTTTBSo',
            MaxLength: '21,6',
            DataType: 'Number',
            Constraint: 'Mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan'
        },
        {
            TargetName: 'Total payment amount in words',
            TagName: 'TgTTTBChu',
            TagNameCheck: 'TgTTTBChu',
            MaxLength: 255,
            DataType: 'String',
            Constraint: 'Mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan'
        },

        // === QR CODE AND DIGITAL SIGNATURE (6 fields for cash register) ===
        {
            TargetName: 'HDon\\DLQRCode contains QR Code data',
            IsTitle: true
        },
        {
            TargetName: 'QR Code data',
            TagName: '',
            TagNameCheck: 'DLQRCode',
            MaxLength: 512,
            DataType: 'String',
            Constraint: 'Not mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DLQRCode'
        },
        {
            TargetName: 'Tag HDon\\MCCQT',
            IsTitle: true,
        },
        {
            TargetName: 'Tax authority code',
            TagName: 'MCCQT',
            TagNameCheck: 'MCCQT',
            MaxLength: 23,
            DataType: 'String',
            Constraint: 'Mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\MCCQT'
        },
        {
            TargetName: 'Tag HDon\\DSCKS\\NBan',
            IsTitle: true
        },
        {
            TargetName: 'Seller digital signature',
            TagName: 'Signature',
            TagNameCheck: 'Signature',
            DataType: '',
            Constraint: 'Not mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DSCKS\\NBan'
        },
        {
            TargetName: 'Tag HDon\\DSCKS\\NMua',
            IsTitle: true
        },
        {
            TargetName: 'Buyer digital signature',
            TagName: 'Signature',
            TagNameCheck: 'Signature',
            DataType: '',
            Constraint: 'Not mandatory',
            IsTitle: false,
            PathRoot: 'HDon\\DSCKS\\NMua'
        }
    ],

    // === SALES INVOICE ND70 ===
    formatXML_BanHang_ND70: [{
        TargetName: 'Tag HDon\\DLHDon\\TTChung',
        IsTitle: true,
        PathRoot: ''
    },
    {
        TargetName: 'XML version',
        TagName: 'PBan',
        MaxLength: 6,
        DataType: 'String',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung'
    },
    {
        TargetName: 'Invoice name',
        TagName: 'THDon',
        MaxLength: 100,
        DataType: 'String',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung'
    },
    {
        TargetName: 'Invoice template symbol',
        TagName: 'KHMSHDon',
        MaxLength: 1,
        DataType: 'String (Details in Appendix II attached to Decision No. 1306/QD-CT)',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung'
    },
    {
        TargetName: 'Invoice symbol',
        TagName: 'KHHDon',
        MaxLength: 6,
        DataType: 'String',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung'
    },
    {
        TargetName: 'Invoice number',
        TagName: 'SHDon',
        MaxLength: 8,
        DataType: 'Number',
        Constraint: 'Mandatory (if available)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung'
    },
    {
        TargetName: 'Profile code',
        TagName: 'MHSo',
        MaxLength: 20,
        DataType: 'String',
        Constraint: 'Mandatory (for invoices requesting tax authority code on each occurrence)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung'
    },
    {
        TargetName: 'Date of issuance',
        TagName: 'NLap',
        DataType: 'Date',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung'
    },
    {
        TargetName: 'Invoice for duty-free zone (Invoice for organizations and individuals in duty-free zones)',
        TagName: 'HDDCKPTQuan',
        MaxLength: 1,
        DataType: 'Number (1: Invoice for organizations and individuals in duty-free zones, 0: Invoice not for organizations and individuals in duty-free zones)',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung'
    },
    {
        TargetName: 'Statement number (Number of statement of goods and services sold with invoice or commercial discount invoice)',
        TagName: 'SBKe',
        MaxLength: 50,
        DataType: 'String',
        Constraint: 'Mandatory (if available)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung'
    },
    {
        TargetName: 'Statement date (Date of statement of goods and services sold with invoice or commercial discount invoice)',
        TagName: 'NBKe',
        DataType: 'Date',
        Constraint: 'Mandatory (if available)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung'
    },
    {
        TargetName: 'Currency unit',
        TagName: 'DVTTe',
        MaxLength: 3,
        DataType: 'String (Details in Section 2, Item IV, Part I attached to Decision No. 1306/QD-CT)',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung'
    },
    {
        TargetName: 'Exchange rate',
        TagName: 'TGia',
        MaxLength: '7,2',
        DataType: 'Number',
        Constraint: 'Mandatory (except when Currency unit is VND)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung'
    },
    {
        TargetName: 'Payment method',
        TagName: 'HTTToan',
        MaxLength: 50,
        DataType: 'String',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung'
    },
    {
        TargetName: 'TIN of organization providing electronic invoice solutions',
        TagName: 'MSTTCGP',
        MaxLength: 14,
        DataType: 'String',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung'
    },
    {
        TargetName: 'TIN of unit authorized to issue invoices',
        TagName: 'MSTDVNUNLHDon',
        MaxLength: 14,
        DataType: 'String',
        Constraint: 'Mandatory (for invoice authorization cases)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung'
    },
    {
        TargetName: 'Name of unit authorized to issue invoices',
        TagName: 'TDVNUNLHDon',
        MaxLength: 400,
        DataType: 'String',
        Constraint: 'Mandatory (for invoice authorization cases)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung'
    },
    {
        TargetName: 'Address of unit authorized to issue invoices',
        TagName: 'DCDVNUNLHDon',
        MaxLength: 400,
        DataType: 'String',
        Constraint: 'Mandatory (for invoice authorization cases)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung'
    },
    {
        TargetName: 'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan contains related invoice information for adjustment or replacement invoices',
        IsTitle: true
    },
    {
        TargetName: 'Invoice nature',
        TagName: 'TCHDon',
        MaxLength: 1,
        DataType: 'Number (1: Replacement, 2: Adjustment, 3: Multiple invoice replacement, 4: Multiple invoice adjustment, 5: Commercial discount)',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan contains related invoice information for adjustment or replacement invoices'
    },
    {
        TargetName: 'Type of related invoice (Type of invoice being replaced/adjusted)',
        TagName: 'LHDCLQuan',
        MaxLength: 1,
        DataType: 'Number (Details in Appendix VI attached to Decision No. 1306/QD-CT)',
        Constraint: 'Mandatory (for adjustment or replacement of 1 invoice)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan contains related invoice information for adjustment or replacement invoices'
    },
    {
        TargetName: 'Template symbol of related invoice (Template symbol of invoice being replaced/adjusted)',
        TagName: 'KHMSHDCLQuan',
        MaxLength: 11,
        DataType: 'String (Details in Appendix II attached to Decision No. 1306/QD-CT)',
        Constraint: 'Mandatory (for adjustment or replacement of 1 invoice with Template symbol, Invoice symbol, Invoice number)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan contains related invoice information for adjustment or replacement invoices'
    },
    {
        TargetName: 'Invoice symbol of related invoice (Invoice symbol of invoice being replaced/adjusted)',
        TagName: 'KHHDCLQuan',
        MaxLength: 8,
        DataType: 'String',
        Constraint: 'Mandatory (for adjustment or replacement of 1 invoice with Template symbol, Invoice symbol, Invoice number)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan contains related invoice information for adjustment or replacement invoices'
    },
    {
        TargetName: 'Invoice number of related invoice (Invoice number of invoice being replaced/adjusted)',
        TagName: 'SHDCLQuan',
        MaxLength: 8,
        DataType: 'String',
        Constraint: 'Mandatory (for adjustment or replacement of 1 invoice with Template symbol, Invoice symbol, Invoice number)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan contains related invoice information for adjustment or replacement invoices'
    },
    {
        TargetName: 'Date of related invoice (Date of invoice being replaced/adjusted)',
        TagName: 'NLHDCLQuan',
        DataType: 'Date',
        Constraint: 'Mandatory (for adjustment or replacement of 1 invoice)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan contains related invoice information for adjustment or replacement invoices'
    },
    {
        TargetName: 'Note',
        TagName: 'GChu',
        MaxLength: 255,
        DataType: 'String',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan contains related invoice information for adjustment or replacement invoices'
    },
    {
        TargetName: 'Related statement number (Replacement/adjustment statement number)',
        TagName: 'SBKCLQuan',
        MaxLength: 50,
        DataType: 'String',
        Constraint: 'Mandatory (for adjustment or replacement of multiple invoices)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan contains related invoice information for adjustment or replacement invoices'
    },
    {
        TargetName: 'Related statement date (Date of replacement/adjustment statement)',
        TagName: 'NBKCLQuan',
        DataType: 'Date',
        Constraint: 'Mandatory (for adjustment or replacement of multiple invoices)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan contains related invoice information for adjustment or replacement invoices'
    },
    {
        TargetName: 'Tag HDon\\DLHDon\\NDHDon\\NBan',
        IsTitle: true
    },
    {
        TargetName: 'Name',
        TagName: 'Ten',
        MaxLength: 400,
        DataType: 'String',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NBan'
    },
    {
        TargetName: 'Tax code',
        TagName: 'MST',
        MaxLength: 14,
        DataType: 'String',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NBan'
    },
    {
        TargetName: 'Address',
        TagName: 'DChi',
        MaxLength: 400,
        DataType: 'String',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NBan'
    },
    {
        TargetName: 'Business location code',
        TagName: 'MDDKDoanh',
        TagNameCheck: 'MDDKDoanh',
        MaxLength: 50,
        DataType: 'String',
        Constraint: 'Mandatory (Household Business/Branch)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NBan'
    },
    {
        TargetName: 'Business location name',
        TagName: 'TDDKDoanh',
        TagNameCheck: 'TDDKDoanh',
        MaxLength: 400,
        DataType: 'String',
        Constraint: 'Mandatory (Household Business/Branch)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NBan'
    },
    {
        TargetName: 'Business location address',
        TagName: 'DCDDKDoanh',
        TagNameCheck: 'DCDDKDoanh',
        MaxLength: 400,
        DataType: 'String',
        Constraint: 'Mandatory (Household Business/Branch)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NBan'
    },
    {
        TargetName: 'Store code',
        TagName: 'MCHang',
        MaxLength: 50,
        DataType: 'String',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NBan'
    },
    {
        TargetName: 'Store name',
        TagName: 'TCHang',
        MaxLength: 400,
        DataType: 'String',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NBan'
    },

    {
        TargetName: 'Phone number',
        TagName: 'SDThoai',
        MaxLength: 20,
        DataType: 'String',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NBan'
    },
    {
        TargetName: 'Email address',
        TagName: 'DCTDTu',
        MaxLength: 50,
        DataType: 'String',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NBan'
    },
    {
        TargetName: 'Bank account number',
        TagName: 'STKNHang',
        MaxLength: 30,
        DataType: 'String',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NBan'
    },
    {
        TargetName: 'Bank name',
        TagName: 'TNHang',
        MaxLength: 400,
        DataType: 'String',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NBan'
    },
    {
        TargetName: 'Fax',
        TagName: 'Fax',
        MaxLength: 20,
        DataType: 'String',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NBan'
    },
    {
        TargetName: 'Website',
        TagName: 'Website',
        MaxLength: 100,
        DataType: 'String',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NBan'
    },
    {
        TargetName: 'Tag HDon\\DLHDon\\NDHDon\\NMua',
        IsTitle: true,
    },
    {
        TargetName: 'Name',
        TagName: 'Ten',
        MaxLength: 400,
        DataType: 'String',
        Constraint: 'Mandatory (if available)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
    },
    {
        TargetName: 'Tax code',
        TagName: 'MST',
        MaxLength: 14,
        DataType: 'String',
        Constraint: 'Mandatory (if available)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
    },
    {
        TargetName: 'Budget relationship unit code (Code of unit with budget relationship)',
        TagName: 'MDVQHNSach',
        MaxLength: 7,
        DataType: 'String',
        Constraint: 'Mandatory (if available)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
    },
    {
        TargetName: 'Address',
        TagName: 'DChi',
        MaxLength: 400,
        DataType: 'String',
        Constraint: 'Mandatory (if available)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
    },
    {
        TargetName: 'Customer code',
        TagName: 'MKHang',
        MaxLength: 50,
        DataType: 'String',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
    },
    {
        TargetName: 'Phone number',
        TagName: 'SDThoai',
        MaxLength: 20,
        DataType: 'String',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
    },
    {
        TargetName: 'Citizen identification card (ID number/Citizen ID/Identification number)',
        TagName: 'CCCDan',
        MaxLength: 12,
        DataType: 'String',
        Constraint: 'Mandatory (if available)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
    },
    {
        TargetName: 'Passport number (Passport number/Immigration documents)',
        TagName: 'SHChieu',
        MaxLength: 20,
        DataType: 'String',
        Constraint: 'Mandatory (if available)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
    },
    {
        TargetName: 'Email address',
        TagName: 'DCTDTu',
        MaxLength: 50,
        DataType: 'String',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
    },
    {
        TargetName: 'Full name of buyer',
        TagName: 'HVTNMHang',
        MaxLength: 100,
        DataType: 'String',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
    },
    {
        TargetName: 'Bank account number',
        TagName: 'STKNHang',
        MaxLength: 30,
        DataType: 'String',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
    },
    {
        TargetName: 'Bank name',
        TagName: 'TNHang',
        MaxLength: 400,
        DataType: 'String',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
    },
    {
        TargetName: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu',
        IsTitle: true
    },
    {
        TargetName: 'Nature',
        TagName: 'TChat',
        MaxLength: 1,
        DataType: 'Number (Details in Appendix IV attached to Decision No. 1306/QD-CT)',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
    },
    {
        TargetName: 'Serial number',
        TagName: 'STT',
        MaxLength: 4,
        DataType: 'Number',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
    },
    {
        TargetName: 'Goods/services code',
        TagName: 'MHHDVu',
        MaxLength: 50,
        DataType: 'String',
        Constraint: 'Mandatory (if available)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
    },
    {
        TargetName: 'Goods/services name',
        TagName: 'THHDVu',
        MaxLength: 500,
        DataType: 'String',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
    },
    {
        TargetName: 'Unit of measurement',
        TagName: 'DVTinh',
        MaxLength: 50,
        DataType: 'String',
        Constraint: 'Mandatory (if available)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
    },
    {
        TargetName: 'Quantity',
        TagName: 'SLuong',
        MaxLength: '21,6',
        DataType: 'Number',
        Constraint: 'Mandatory (if available)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
    },
    {
        TargetName: 'Unit price',
        TagName: 'DGia',
        MaxLength: '21,6',
        DataType: 'Number',
        Constraint: 'Mandatory (if available)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
    },
    {
        TargetName: 'Discount rate percentage (for displaying discount information for each goods/service)',
        TagName: 'TLCKhau',
        MaxLength: '6,4',
        DataType: 'Number',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
    },
    {
        TargetName: 'Discount amount (for displaying discount information for each goods/service)',
        TagName: 'STCKhau',
        MaxLength: '21,6',
        DataType: 'Number',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
    },
    {
        TargetName: 'Amount',
        TagName: 'ThTien',
        MaxLength: '21,6',
        DataType: 'Number',
        Constraint: 'Mandatory (except when TChat value is "4-Note/explanation")',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
    },
    {
        TargetName: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu\\TTHHDTrung contains list of special goods information (mandatory if TChat tag value is "5")',
        IsTitle: true
    },
    {
        TargetName: 'Special goods type',
        TagName: 'LHHDTrung',
        MaxLength: 1,
        DataType: 'Number (Details in Appendix XV attached to Decision No. 1306/QD-CT)',
        Constraint: 'Mandatory (if available)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu\\TTHHDTrung contains list of special goods information (mandatory if TChat tag value is "5")'
    },
    {
        TargetName: 'Field name',
        TagName: 'TTruong',
        MaxLength: 20,
        DataType: 'String (Details in "Mandatory value" column in Appendix XV of this Decision)',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu\\TTHHDTrung contains list of special goods information (mandatory if TChat tag value is "5")'
    },
    {
        TargetName: 'Data',
        TagName: 'DLieu',
        MaxLength: 200,
        DataType: '',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu\\TTHHDTrung contains list of special goods information (mandatory if TChat tag value is "5")'
    },
    {
        TargetName: 'Tag HDon\\DLHDon\\NDHDon\\TToan',
        IsTitle: true
    },
    {
        TargetName: 'Tag HDon\\DLHDon\\NDHDon\\TToan\\DSLPhi\\LPhi',
        IsTitle: true
    },
    {
        TargetName: 'Fee type name',
        TagName: 'TLPhi',
        MaxLength: 100,
        DataType: 'String',
        Constraint: 'Mandatory (if available)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\TToan\\DSLPhi\\LPhi'
    },
    {
        TargetName: 'Fee amount',
        TagName: 'TPhi',
        MaxLength: '21,6',
        DataType: 'Number',
        Constraint: 'Mandatory (if available)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\TToan\\DSLPhi\\LPhi'
    },
    {
        TargetName: 'Following items are placed inside tag HDon\\DLHDon\\NDHDon\\TToan',
        IsTitle: true
    },
    {
        TargetName: 'Total commercial discount amount',
        TagName: 'TTCKTMai',
        MaxLength: '21,6',
        DataType: 'Number',
        Constraint: 'Mandatory (if available)',
        IsTitle: false,
        PathRoot: 'Following items are placed inside tag HDon\\DLHDon\\NDHDon\\TToan'
    },
    {
        TargetName: 'Total other deductions',
        TagName: 'TGTKhac',
        MaxLength: '21,6',
        DataType: 'Number',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Following items are placed inside tag HDon\\DLHDon\\NDHDon\\TToan'
    },
    {
        TargetName: 'Total payment amount in numbers',
        TagName: 'TgTTTBSo',
        MaxLength: '21,6',
        DataType: 'Number',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'Following items are placed inside tag HDon\\DLHDon\\NDHDon\\TToan'
    },
    {
        TargetName: 'Total payment amount in words',
        TagName: 'TgTTTBChu',
        MaxLength: 255,
        DataType: 'String',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'Following items are placed inside tag HDon\\DLHDon\\NDHDon\\TToan'
    },
    {
        TargetName: 'Tag HDon\\DLQRCode contains QR Code data',
        IsTitle: true
    },
    {
        TargetName: 'QR Code data',
        MaxLength: 512,
        DataType: 'String',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLQRCode contains QR Code data'
    },
    {
        TargetName: 'For coded electronic invoices, if conditions are met for code issuance, tax authority system returns Tax authority code item on electronic invoice (MCCQT tag, placed inside HDon tag)',
        IsTitle: true
    },
    {
        TargetName: 'Tax authority code',
        TagName: 'MCCQT',
        MaxLength: 34,
        DataType: 'String',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'For coded electronic invoices, if conditions are met for code issuance, tax authority system returns Tax authority code item on electronic invoice (MCCQT tag, placed inside HDon tag)'
    },
    {
        TargetName: 'Tag HDon\\DSCKS\\NBan',
        IsTitle: true
    },
    {
        TargetName: 'Seller digital signature',
        TagName: 'Signature',
        Constraint: 'Mandatory (if available)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DSCKS\\NBan'
    },
    {
        TargetName: 'Tag HDon\\DSCKS\\NMua',
        IsTitle: true
    },
    {
        TargetName: 'Buyer digital signature',
        TagName: 'Signature',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DSCKS\\NMua'
    },
    {
        TargetName: 'For electronic invoices eligible for code issuance, tax authority system returns electronic invoice and adds CQT tag (placed inside HDon\\DSCKS tag) containing tax authority digital signature information (signed on HDon\\DLHDon tag, HDon\\MCCQT tag and HDon\\DSCKS\\CQT\\Signature\\Object tag)',
        IsTitle: true
    },
    {
        TargetName: 'Tax authority digital signature',
        TagName: 'Signature',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'For electronic invoices eligible for code issuance, tax authority system returns electronic invoice and adds CQT tag (placed inside HDon\\DSCKS tag) containing tax authority digital signature information (signed on HDon\\DLHDon tag, HDon\\MCCQT tag and HDon\\DSCKS\\CQT\\Signature\\Object tag)'
    }
    ],

    // === SALES INVOICE FOR CASH REGISTER ND70 ===
    formatXML_BH_MTT_ND70: [{
        TargetName: 'Tag HDon\\DLHDon\\TTChung',
        IsTitle: true,
        PathRoot: ''
    },
    {
        TargetName: 'Message version',
        TagName: 'PBan',
        MaxLength: 6,
        DataType: 'String',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung'
    },
    {
        TargetName: 'Invoice name',
        TagName: 'THDon',
        MaxLength: 100,
        DataType: 'String',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung'
    },
    {
        TargetName: 'Invoice template symbol',
        TagName: 'KHMSHDon',
        MaxLength: 1,
        DataType: 'String (Details in Appendix II attached to Decision No. 1306/QD-CT)',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung'
    },
    {
        TargetName: 'Invoice symbol',
        TagName: 'KHHDon',
        MaxLength: 6,
        DataType: 'String',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung'
    },
    {
        TargetName: 'Invoice number',
        TagName: 'SHDon',
        MaxLength: 8,
        DataType: 'Number',
        Constraint: 'Mandatory (if available)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung'
    },
    {
        TargetName: 'Date of issuance',
        TagName: 'NLap',
        DataType: 'Date',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung'
    },
    {
        TargetName: 'Statement number (Number of statement of goods and services sold with invoice or commercial discount invoice)',
        TagName: 'SBKe',
        MaxLength: 50,
        DataType: 'String',
        Constraint: 'Mandatory (if available)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung'
    },
    {
        TargetName: 'Statement date (Date of statement of goods and services sold with invoice or commercial discount invoice)',
        TagName: 'NBKe',
        DataType: 'Date',
        Constraint: 'Mandatory (if available)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung'
    },
    {
        TargetName: 'Payment method',
        TagName: 'HTTToan',
        MaxLength: 50,
        DataType: 'String',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung'
    },
    {
        TargetName: 'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan contains related invoice information for adjustment or replacement invoices',
        IsTitle: true
    },
    {
        TargetName: 'Invoice nature',
        TagName: 'TCHDon',
        MaxLength: 1,
        DataType: 'Number (1: Replacement, 2: Adjustment, 5: Commercial discount)',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan contains related invoice information for adjustment or replacement invoices'
    },
    {
        TargetName: 'Type of related invoice (Type of invoice being replaced/adjusted)',
        TagName: 'LHDCLQuan',
        MaxLength: 1,
        DataType: 'Number (Details in Appendix VI attached to Decision No. 1306/QD-CT)',
        Constraint: 'Mandatory (for adjustment or replacement of 1 invoice)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan contains related invoice information for adjustment or replacement invoices'
    },
    {
        TargetName: 'Template symbol of related invoice (Template symbol of invoice being replaced/adjusted)',
        TagName: 'KHMSHDCLQuan',
        MaxLength: 11,
        DataType: 'String (Details in Appendix II attached to Decision No. 1306/QD-CT)',
        Constraint: 'Mandatory (for adjustment or replacement of 1 invoice)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan contains related invoice information for adjustment or replacement invoices'
    },
    {
        TargetName: 'Invoice symbol of related invoice (Invoice symbol of invoice being replaced/adjusted)',
        TagName: 'KHHDCLQuan',
        MaxLength: 8,
        DataType: 'String',
        Constraint: 'Mandatory (for adjustment or replacement of 1 invoice)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan contains related invoice information for adjustment or replacement invoices'
    },
    {
        TargetName: 'Invoice number of related invoice (Invoice number of invoice being replaced/adjusted)',
        TagName: 'SHDCLQuan',
        MaxLength: 8,
        DataType: 'String',
        Constraint: 'Mandatory (for adjustment or replacement of 1 invoice)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan contains related invoice information for adjustment or replacement invoices'
    },
    {
        TargetName: 'Date of related invoice (Date of invoice being replaced/adjusted)',
        TagName: 'NLHDCLQuan',
        DataType: 'Ngày',
        Constraint: 'Mandatory (for adjustment or replacement of 1 invoice)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan contains related invoice information for adjustment or replacement invoices'
    },
    {
        TargetName: 'Tag HDon\\DLHDon\\NDHDon\\NBan',
        IsTitle: true
    },
    {
        TargetName: 'Seller unit name',
        TagName: 'Ten',
        MaxLength: 400,
        DataType: 'String',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NBan'
    },
    {
        TargetName: 'Tax code',
        TagName: 'MST',
        MaxLength: 14,
        DataType: 'String',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NBan'
    },
    {
        TargetName: 'Address',
        TagName: 'DChi',
        MaxLength: 400,
        DataType: 'String',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NBan'
    },
    {
        TargetName: 'Business location code',
        TagName: 'MDDKDoanh',
        TagNameCheck: 'MDDKDoanh',
        MaxLength: 50,
        DataType: 'String',
        Constraint: 'Mandatory (Household Business/Branch)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NBan'
    },
    {
        TargetName: 'Business location name',
        TagName: 'TDDKDoanh',
        TagNameCheck: 'TDDKDoanh',
        MaxLength: 400,
        DataType: 'String',
        Constraint: 'Mandatory (Household Business/Branch)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NBan'
    },
    {
        TargetName: 'Business location address',
        TagName: 'DCDDKDoanh',
        TagNameCheck: 'DCDDKDoanh',
        MaxLength: 400,
        DataType: 'String',
        Constraint: 'Mandatory (Household Business/Branch)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NBan'
    },
    {
        TargetName: 'Store code',
        TagName: 'MCHang',
        MaxLength: 50,
        DataType: 'String',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NBan'
    },
    {
        TargetName: 'Store name',
        TagName: 'TCHang',
        MaxLength: 400,
        DataType: 'String',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NBan'
    },

    {
        TargetName: 'Phone number',
        TagName: 'SDThoai',
        MaxLength: 20,
        DataType: 'String',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NBan'
    },
    {
        TargetName: 'Bank number',
        TagName: 'STKNHang',
        MaxLength: 30,
        DataType: 'String',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NBan'
    },
    {
        TargetName: 'Bank name',
        TagName: 'TNHang',
        MaxLength: 400,
        DataType: 'String',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NBan'
    },
    {
        TargetName: 'Tag HDon\\DLHDon\\NDHDon\\NMua',
        IsTitle: true,
    },
    {
        TargetName: 'Name',
        TagName: 'Ten',
        MaxLength: 400,
        DataType: 'String',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
    },
    {
        TargetName: 'Tax code',
        TagName: 'MST',
        MaxLength: 14,
        DataType: 'String',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
    },
    {
        TargetName: 'Address',
        TagName: 'DChi',
        MaxLength: 400,
        DataType: 'String',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
    },
    {
        TargetName: 'Budget relationship unit code (Code of unit with budget relationship)',
        TagName: 'MDVQHNSach',
        MaxLength: 7,
        DataType: 'String',
        Constraint: 'Mandatory (if available)',
        IsTitle: false,
        PathRoot: 'Tag Hdon\\DLHDon\\NDHDon\\NMua'
    },
    {
        TargetName: 'Phone number',
        TagName: 'SDThoai',
        MaxLength: 20,
        DataType: 'String',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
    },
    {
        TargetName: 'Citizen identification card (ID number/Citizen ID/Identification number)',
        TagName: 'CCCDan',
        MaxLength: 12,
        DataType: 'String',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag Hdon\\DLHDon\\NDHDon\\NMua'
    },
    {
        TargetName: 'Passport number (Passport number/Immigration documents)',
        TagName: 'SHChieu',
        MaxLength: 20,
        DataType: 'String',
        Constraint: 'Mandatory (if available)',
        IsTitle: false,
        PathRoot: 'Tag Hdon\\DLHDon\\NDHDon\\NMua'
    },
    {
        TargetName: 'Full name of buyer',
        TagName: 'HVTNMHang',
        MaxLength: 100,
        DataType: 'String',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
    },
    {
        TargetName: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu',
        IsTitle: true
    },
    {
        TargetName: 'Nature',
        TagName: 'TChat',
        MaxLength: 1,
        DataType: 'Number (Details in Appendix IV attached to Decision No. 1306/QD-CT)',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
    },
    {
        TargetName: 'Serial number',
        TagName: 'STT',
        MaxLength: 4,
        DataType: 'Number',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
    },
    {
        TargetName: 'Goods/services code',
        TagName: 'MHHDVu',
        MaxLength: 50,
        DataType: 'String',
        Constraint: 'Mandatory (if available)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
    },
    {
        TargetName: 'Goods/services name',
        TagName: 'THHDVu',
        MaxLength: 500,
        DataType: 'String',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
    },
    {
        TargetName: 'Unit of measurement',
        TagName: 'DVTinh',
        MaxLength: 50,
        DataType: 'String',
        Constraint: 'Mandatory (if available)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
    },
    {
        TargetName: 'Quantity',
        TagName: 'SLuong',
        MaxLength: '21,6',
        DataType: 'Number',
        Constraint: 'Mandatory (if available)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
    },
    {
        TargetName: 'Unit price',
        TagName: 'DGia',
        MaxLength: '21,6',
        DataType: 'Number',
        Constraint: 'Mandatory (if available)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
    },
    {
        TargetName: 'Discount rate percentage (for displaying discount information for each goods/service)',
        TagName: 'TLCKhau',
        MaxLength: '6,4',
        DataType: 'Number',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
    },
    {
        TargetName: 'Discount amount (for displaying discount information for each goods/service)',
        TagName: 'STCKhau',
        MaxLength: '21,6',
        DataType: 'Number',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
    },
    {
        TargetName: 'Amount',
        TagName: 'ThTien',
        MaxLength: '21,6',
        DataType: 'Number',
        Constraint: 'Mandatory (except when TChat value is "4-Note/explanation")',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
    },
    {
        TargetName: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu\\TTHHDTrung contains list of special goods information (mandatory if TChat tag value is "5")',
        IsTitle: true
    },
    {
        TargetName: 'Special goods type',
        TagName: 'LHHDTrung',
        MaxLength: 1,
        DataType: 'Number (Details in Appendix XV attached to Decision No. 1306/QD-CT)',
        Constraint: 'Mandatory (if available)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu\\TTHHDTrung contains list of special goods information (mandatory if TChat tag value is "5")'
    },
    {
        TargetName: 'Field name',
        TagName: 'TTruong',
        MaxLength: 20,
        DataType: 'String (Details in "Mandatory value" column in Appendix XV of this Decision)',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu\\TTHHDTrung contains list of special goods information (mandatory if TChat tag value is "5")'
    },
    {
        TargetName: 'Data',
        TagName: 'DLieu',
        MaxLength: 200,
        DataType: '',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu\\TTHHDTrung contains list of special goods information (mandatory if TChat tag value is "5")'
    },
    {
        TargetName: 'Tag HDon\\DLHDon\\NDHDon\\TToan',
        IsTitle: true
    },
    {
        TargetName: 'Total commercial discount amount',
        TagName: 'TTCKTMai',
        MaxLength: '21,6',
        DataType: 'Number',
        Constraint: 'Mandatory (if available)',
        IsTitle: false,
        PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan'
    },
    {
        TargetName: 'Total payment amount in numbers',
        TagName: 'TgTTTBSo',
        MaxLength: '21,6',
        DataType: 'Number',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan'
    },
    {
        TargetName: 'Total payment amount in words',
        TagName: 'TgTTTBChu',
        MaxLength: 255,
        DataType: 'String',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan'
    },
    {
        TargetName: 'Tag HDon\\DLQRCode contains data QR Code',
        IsTitle: true
    },
    {
        TargetName: 'Data QR Code',
        MaxLength: 512,
        DataType: 'String',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLQRCode contains data QR Code'
    },
    {
        TargetName: 'Tag HDon\\MCCQT',
        IsTitle: true
    },
    {
        TargetName: 'Tax authority code',
        TagName: 'MCCQT',
        TagNameCheck: 'MCCQT',
        MaxLength: 23,
        DataType: 'String',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'HDon\\MCCQT'
    },
    {
        TargetName: 'Tag HDon\\DSCKS\\NBan',
        IsTitle: true
    },
    {
        TargetName: 'Seller digital signature',
        TagName: 'Signature',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DSCKS\\NBan'
    },
    {
        TargetName: 'Tag HDon\\DSCKS\\NMua',
        IsTitle: true
    },
    {
        TargetName: 'Buyer digital signature',
        TagName: 'Signature',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DSCKS\\NMua'
    },
    ],

    // === VAT TICKET ND70 ===
    formatXML_GTGT_Ticket_ND70: [{
        TargetName: 'Tag HDon\\DLHDon\\TTChung',
        IsTitle: true,
        PathRoot: ''
    },
    {
        TargetName: 'Message version',
        TagName: 'PBan',
        MaxLength: 6,
        DataType: 'String',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung'
    },
    {
        TargetName: 'Invoice name',
        TagName: 'THDon',
        MaxLength: 100,
        DataType: 'String',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung'
    },
    {
        TargetName: 'Invoice template symbol',
        TagName: 'KHMSHDon',
        MaxLength: 1,
        DataType: 'String (Details in Appendix II attached to Decision No. 1306/QD-CT)',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung'
    },
    {
        TargetName: 'Invoice symbol',
        TagName: 'KHHDon',
        MaxLength: 6,
        DataType: 'String',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung'
    },
    {
        TargetName: 'Invoice number',
        TagName: 'SHDon',
        MaxLength: 8,
        DataType: 'Number',
        Constraint: 'Mandatory (if available)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung'
    },
    {
        TargetName: 'Date of issuance',
        TagName: 'NLap',
        DataType: 'Date',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung'
    },
    {
        TargetName: 'Currency unit',
        TagName: 'DVTTe',
        TagNameCheck: 'DVTTe',
        MaxLength: 3,
        DataType: 'String (Details in Section 2, Item IV, Part I attached to Decision No. 1306/QD-CT)',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung'
    },
    {
        TargetName: 'Exchange rate',
        TagName: 'TGia',
        TagNameCheck: 'TGia',
        MaxLength: '7,2',
        DataType: 'Number',
        Constraint: 'Mandatory (except when Currency unit is VND)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung'
    },
    {
        TargetName: 'Payment method',
        TagName: 'HTTToan',
        MaxLength: 50,
        DataType: 'String',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung'
    },
    {
        TargetName: 'Tax code of organization providing electronic invoice solutions',
        TagName: 'MSTTCGP',
        TagNameCheck: 'MSTTCGP',
        MaxLength: 14,
        DataType: 'String',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung'
    },
    {
        TargetName: 'Tax code of unit authorized to issue invoices',
        TagName: 'MSTDVNUNLHDon',
        TagNameCheck: 'MSTDVNUNLHDon',
        MaxLength: 14,
        DataType: 'String',
        Constraint: 'Mandatory (for invoice authorization cases)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung'
    },
    {
        TargetName: 'Name of unit authorized to issue invoices',
        TagName: 'TDVNUNLHDon',
        MaxLength: 400,
        DataType: 'String',
        Constraint: 'Mandatory (for invoice authorization cases)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung'
    },
    {
        TargetName: 'Address of unit authorized to issue invoices',
        TagName: 'DCDVNUNLHDon',
        MaxLength: 400,
        DataType: 'String',
        Constraint: 'Mandatory (for invoice authorization cases)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung'
    },
    {
        TargetName: 'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan contains related invoice information for adjustment or replacement invoices',
        IsTitle: true
    },
    {
        TargetName: 'Invoice nature',
        TagName: 'TCHDon',
        MaxLength: 1,
        DataType: 'Number (1: Replacement, 2: Adjustment)',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan contains related invoice information for adjustment or replacement invoices'
    },
    {
        TargetName: 'Type of related invoice (TYpe of invoice being replaced/adjusted)',
        TagName: 'LHDCLQuan',
        MaxLength: 1,
        DataType: 'Number (Details in Appendix VI attached to Decision No. 1306/QĐ-CT)',
        Constraint: 'Mandatory (For adjustment or replacement for one invoice)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan contains related invoice information for adjustment or replacement invoices'
    },
    {
        TargetName: 'Template symbol of related invoice (Template symbol of invoice being replaced/adjusted)',
        TagName: 'KHMSHDCLQuan',
        MaxLength: 11,
        DataType: 'String (Details in Appendix II attached to Decision No. 1306/QĐ-CT)',
        Constraint: 'Mandatory (for adjustment or replacement of 1 invoice with Template symbol, Invoice symbol, Invoice number)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan contains related invoice information for adjustment or replacement invoices'
    },
    {
        TargetName: 'Invoice symbol of related invoice (Invoice symbol of invoice being replaced/adjusted)',
        TagName: 'KHHDCLQuan',
        MaxLength: 8,
        DataType: 'String',
        Constraint: 'Mandatory (for adjustment or replacement of 1 invoice with Template symbol, Invoice symbol, Invoice number)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan contains related invoice information for adjustment or replacement invoices'
    },
    {
        TargetName: 'Invoice number of related invoice (Invoice number of invoice being replaced/adjusted)',
        TagName: 'SHDCLQuan',
        MaxLength: 8,
        DataType: 'String',
        Constraint: 'Mandatory (for adjustment or replacement of 1 invoice with Template symbol, Invoice symbol, Invoice number)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan contains related invoice information for adjustment or replacement invoices'
    },
    {
        TargetName: 'Date of replated invoice (Date of invoice being replaced/adjusted)',
        TagName: 'NLHDCLQuan',
        DataType: 'Date',
        Constraint: 'Mandatory (for adjustment or replacement of one invoice)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan contains related invoice information for adjustment or replacement invoices'
    },
    {
        TargetName: 'Note',
        TagName: 'GChu',
        MaxLength: 255,
        DataType: 'String',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\TTChung\\TTHDLQuan contains related invoice information for adjustment or replacement invoices'
    },
    {
        TargetName: 'Tag HDon\\DLHDon\\NDHDon\\NBan',
        IsTitle: true
    },
    {
        TargetName: 'Seller unit name',
        TagName: 'Ten',
        MaxLength: 400,
        DataType: 'String',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NBan'
    },
    {
        TargetName: 'Tax code',
        TagName: 'MST',
        MaxLength: 14,
        DataType: 'String',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NBan'
    },
    {
        TargetName: 'Address',
        TagName: 'DChi',
        MaxLength: 400,
        DataType: 'String',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NBan'
    },
    {
        TargetName: 'Store code',
        TagName: 'MCHang',
        MaxLength: 50,
        DataType: 'String',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NBan'
    },
    {
        TargetName: 'Store name',
        TagName: 'TCHang',
        MaxLength: 400,
        DataType: 'String',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NBan'
    },
    {
        TargetName: 'Phone number',
        TagName: 'SDThoai',
        MaxLength: 20,
        DataType: 'String',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NBan'
    },
    {
        TargetName: 'Email address',
        TagName: 'DCTDTu',
        TagNameCheck: 'DCTDTu',
        MaxLength: 50,
        DataType: 'String',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'HDon\\DLHDon\\NDHDon\\NBan'
    },
    {
        TargetName: 'Bank account number',
        TagName: 'STKNHang',
        MaxLength: 30,
        DataType: 'String',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NBan'
    },
    {
        TargetName: 'Bank name',
        TagName: 'TNHang',
        MaxLength: 400,
        DataType: 'String',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NBan'
    },
    {
        TargetName: 'Fax',
        TagName: 'Fax',
        TagNameCheck: 'Fax',
        MaxLength: 20,
        DataType: 'String',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NBan'
    },
    {
        TargetName: 'Website',
        TagName: 'Website',
        TagNameCheck: 'Website',
        MaxLength: 100,
        DataType: 'String',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NBan'
    },
    {
        TargetName: 'Tag HDon\\DLHDon\\NDHDon\\NMua',
        IsTitle: true,
    },
    {
        TargetName: 'Name',
        TagName: 'Ten',
        MaxLength: 400,
        DataType: 'String',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
    },
    {
        TargetName: 'Tax code',
        TagName: 'MST',
        MaxLength: 14,
        DataType: 'String',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
    },
    {
        TargetName: 'Budget relationship unit code (Code of unit with budget relationship)',
        TagName: 'MDVQHNSach',
        MaxLength: 7,
        DataType: 'String',
        Constraint: 'Mandatory (if available)',
        IsTitle: false,
        PathRoot: 'Tag Hdon\\DLHDon\\NDHDon\\NMua'
    },
    {
        TargetName: 'Address',
        TagName: 'DChi',
        MaxLength: 400,
        DataType: 'String',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
    },
    {
        TargetName: 'Customer code',
        TagName: 'MKHang',
        TagNameCheck: 'MKHang',
        MaxLength: 50,
        DataType: 'String',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
    },
    {
        TargetName: 'Phone number',
        TagName: 'SDThoai',
        MaxLength: 20,
        DataType: 'String',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
    },
    {
        TargetName: 'Citizen identification card (ID number/Citizen ID/Identification number)',
        TagName: 'CCCDan',
        MaxLength: 12,
        DataType: 'String',
        Constraint: 'Mandatory (if available)',
        IsTitle: false,
        PathRoot: 'Tag Hdon\\DLHDon\\NDHDon\\NMua'
    },
    {
        TargetName: 'Passport number (Passport number/Immigration documents)',
        TagName: 'SHChieu',
        MaxLength: 20,
        DataType: 'String',
        Constraint: 'Mandatory (if available)',
        IsTitle: false,
        PathRoot: 'Tag Hdon\\DLHDon\\NDHDon\\NMua'
    },
    {
        TargetName: 'Email address',
        TagName: 'DCTDTu',
        TagNameCheck: 'DCTDTu',
        MaxLength: 50,
        DataType: 'String',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
    },
    {
        TargetName: 'Full name of buyer',
        TagName: 'HVTNMHang',
        MaxLength: 100,
        DataType: 'String',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
    },
    {
        TargetName: 'Bank account number',
        TagName: 'STKNHang',
        TagNameCheck: 'STKNHang',
        MaxLength: 30,
        DataType: 'String',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
    },
    {
        TargetName: 'Bank name',
        TagName: 'TNHang',
        TagNameCheck: 'TNHang',
        MaxLength: 400,
        DataType: 'String',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\NMua'
    },
    {
        TargetName: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu',
        IsTitle: true
    },
    {
        TargetName: 'Nature',
        TagName: 'TChat',
        MaxLength: 1,
        DataType: 'Number (Details in Appendix IV attached to Decision No. 1306/QD-CT)',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
    },
    {
        TargetName: 'Serial number',
        TagName: 'STT',
        MaxLength: 4,
        DataType: 'Number',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
    },
    {
        TargetName: 'Good/services code',
        TagName: 'MHHDVu',
        MaxLength: 50,
        DataType: 'String',
        Constraint: 'Mandatory (if available)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
    },
    {
        TargetName: 'Good/Service name',
        TagName: 'THHDVu',
        MaxLength: 500,
        DataType: 'String',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
    },
    {
        TargetName: 'Unit of measurement',
        TagName: 'DVTinh',
        MaxLength: 50,
        DataType: 'String',
        Constraint: 'Mandatory (if available)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
    },
    {
        TargetName: 'Quantiry',
        TagName: 'SLuong',
        MaxLength: '21,6',
        DataType: 'Number',
        Constraint: 'Mandatory (if available)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
    },
    {
        TargetName: 'Unit price',
        TagName: 'DGia',
        MaxLength: '21,6',
        DataType: 'Number',
        Constraint: 'Mandatory (if available)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
    },
    {
        TargetName: 'Discount rate percentage (for displaying discount information for each goods/service)',
        TagName: 'TLCKhau',
        MaxLength: '6,4',
        DataType: 'Number',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
    },
    {
        TargetName: 'Discount amount (for displaying discount information for each goods/service)',
        TagName: 'STCKhau',
        MaxLength: '21,6',
        DataType: 'Number',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
    },
    {
        TargetName: 'Amount (pre-tax amount for other invoices under VAT invoice category, total amount for other invoices under sales invoice category)',
        TagName: 'ThTien',
        MaxLength: '21,6',
        DataType: 'Number',
        Constraint: 'Mandatory (except when TChat value is "4-Note/explanation")',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
    },
    {
        TargetName: 'Tax rate (VAT rate for other invoices under VAT invoice category, this tag is not applicable for other invoices under sales invoice category)',
        TagName: 'TSuat',
        TagNameCheck: 'TSuat',
        MaxLength: 11,
        DataType: 'String (Details in Appendix V Decision No. 1306/QD-CT)',
        Constraint: 'Mandatory (if available)',
        IsTitle: false,
        PathRoot: 'HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu'
    },
    {
        TargetName: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu\\TTHHDTrung contains special goods information list (mandatory if TChat tag value is "5")',
        IsTitle: true
    },
    {
        TargetName: 'Special goods type',
        TagName: 'LHHDTrung',
        MaxLength: 1,
        DataType: 'Number (Details in Appendix XV, Decision No. 1306/QD-CT)',
        Constraint: 'Mandatory (if available)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu\\TTHHDTrung contains special goods information list (mandatory if TChat tag value is "5")'
    },
    {
        TargetName: 'Feild name',
        TagName: 'TTruong',
        MaxLength: 20,
        DataType: 'String (Details in "Mandatory value" column in Appendix XV Decision No. 1306/QD-CT)',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu\\TTHHDTrung contains special goods information list (mandatory if TChat tag value is "5")'
    },
    {
        TargetName: 'Data',
        TagName: 'DLieu',
        MaxLength: 200,
        DataType: '',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\DSHHDVu\\HHDVu\\TTHHDTrung contains special goods information list (mandatory if TChat tag value is "5")'
    },
    {
        TargetName: 'Tag HDon\\DLHDon\\NDHDon\\TToan',
        IsTitle: true
    },
    {
        TargetName: 'Tag HDon\\DLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat',
        IsTitle: true
    },
    {
        TargetName: 'Tax rate (VAT tax rate)',
        TagName: 'TSuat',
        TagNameCheck: 'TSuat',
        MaxLength: 11,
        DataType: 'String (Details in Appendix V Decision No. 1306/QD-CT)',
        Constraint: 'Mandatory (if available)',
        IsTitle: false,
        PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat'
    },
    {
        TargetName: 'Amount (Amount excluding VAT)',
        TagName: 'ThTien',
        TagNameCheck: 'ThTien',
        MaxLength: '21,6',
        DataType: 'Number',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat'
    },
    {
        TargetName: 'Tax amount (VAT tax amount)',
        TagName: 'TThue',
        TagNameCheck: 'TThue',
        MaxLength: '21,6',
        DataType: 'Number',
        Constraint: 'Mandatory (if available)',
        IsTitle: false,
        PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan\\THTTLTSuat\\LTSuat'
    },
    {
        TargetName: 'Tag HDon\\DLHDon\\NDHDon\\TToan (other invoices that belong to sales invoice type do not have this tag)',
        IsTitle: true
    },
    {
        TargetName: 'Total amount excluding tax (Total amount excluding VAT)',
        TagName: 'TgTCThue',
        TagNameCheck: 'TgTCThue',
        MaxLength: '21,6',
        DataType: 'Number',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\TToan'
    },
    {
        TargetName: 'Total non-taxable deduction',
        TagName: 'TGTKCThue',
        TagNameCheck: 'TGTKCThue',
        MaxLength: '21,6',
        DataType: 'Number',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\TToan'
    },
    {
        TargetName: 'Total tax amount (Total VAT amount)',
        TagName: 'TgTThue',
        TagNameCheck: 'TgTThue',
        MaxLength: '21,6',
        DataType: 'Number',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan'
    },
    {
        TargetName: 'Tag HDon\\DLHDon\\NDHDon\\TToan\\DSLPhi\\LPhi',
        IsTitle: true
    },
    {
        TargetName: 'Fee type name',
        TagName: 'TLPhi',
        TagNameCheck: 'TLPhi',
        MaxLength: 100,
        DataType: 'String',
        Constraint: 'Mandatory (if available)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\TToan\\DSLPhi\\LPhi'
    },
    {
        TargetName: 'Fee name',
        TagName: 'TPhi',
        TagNameCheck: 'TPhi',
        MaxLength: '21,6',
        DataType: 'Number',
        Constraint: 'Mandatory (if available)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLHDon\\NDHDon\\TToan\\DSLPhi\\LPhi'
    },
    {
        TargetName: 'Following items are placed inside tag HDon\\DLHDon\\NDHDon\\TToan',
        IsTitle: true
    },
    {
        TargetName: 'Total commercial discount amount',
        TagName: 'TTCKTMai',
        MaxLength: '21,6',
        DataType: 'Number',
        Constraint: 'Mandatory (if available)',
        IsTitle: false,
        PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan'
    },
    {
        TargetName: 'Total other deductions',
        TagName: 'TGTKhac',
        TagNameCheck: 'TGTKhac',
        MaxLength: '21,6',
        DataType: 'Number',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan'
    },
    {
        TargetName: 'Total payment amount in numbers',
        TagName: 'TgTTTBSo',
        MaxLength: '21,6',
        DataType: 'Number',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan'
    },
    {
        TargetName: 'Total payment amount in words',
        TagName: 'TgTTTBChu',
        MaxLength: 255,
        DataType: 'String',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'HDon\\DLHDon\\NDHDon\\TToan'
    },
    {
        TargetName: 'Tag HDon\\DLQRCode',
        IsTitle: true
    },
    {
        TargetName: 'Data QR Code',
        MaxLength: 512,
        DataType: 'String',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DLQRCode'
    },
    {
        TargetName: 'For coded electronic invoices, if conditions are met for code issuance, tax authority system returns Tax authority code item on electronic invoice (MCCQT tag, placed inside HDon tag)',
        IsTitle: true
    },
    {
        TargetName: 'Tax authority code',
        TagName: 'MCCQT',
        TagNameCheck: 'MCCQT',
        MaxLength: 34,
        DataType: 'String',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'HDon'
    },
    {
        TargetName: 'Tag HDon\\DSCKS\\NBan',
        IsTitle: true
    },
    {
        TargetName: 'Seller digital signature',
        TagName: 'Signature',
        Constraint: 'Mandatory (if available)',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DSCKS\\NBan'
    },
    {
        TargetName: 'Tag HDon\\DSCKS\\NMua',
        IsTitle: true
    },
    {
        TargetName: 'Buyer digital signature',
        TagName: 'Signature',
        Constraint: 'Not mandatory',
        IsTitle: false,
        PathRoot: 'Tag HDon\\DSCKS\\NMua'
    },
    {
        TargetName: 'For electronic invoices eligible for code issuance, tax authority system returns electronic invoice and adds CQT tag (placed inside HDon\\DSCKS tag) containing tax authority digital signature information (signed on HDon\\DLHDon tag, HDon\\MCCQT tag and HDon\\DSCKS\\CQT\\Signature\\Object tag)',
        IsTitle: true
    },
    {
        TargetName: 'Tax authority digital signature',
        TagName: 'Signature',
        TagNameCheck: 'Signature',
        DataType: '',
        Constraint: 'Mandatory',
        IsTitle: false,
        PathRoot: 'HDon\\DSCKS\\CQT'
    }
    ]
}